import React from "react";
import ProductTemplate from "../../ProductTemplate";
import s650Cover from "../../../assets/s650/S650Cover.png";
import s650a from "../../../assets/s650/s650a.webp";
import s650b from "../../../assets/s650/s650b.webp";
import s650c from "../../../assets/s650/s650c.webp";
import s650d from "../../../assets/s650/s650d.webp";
import s6501 from "../../../assets/s650/s6501.webp";
import s6502 from "../../../assets/s650/s6502.webp";
import s6503 from "../../../assets/s650/s6503.webp";
import s6504 from "../../../assets/s650/s6504.webp";
import s6505 from "../../../assets/s650/s6505.webp";
import s6506 from "../../../assets/s650/s6506.webp";
import s6507 from "../../../assets/s650/s6507.webp";
import s6508 from "../../../assets/s650/s6508.webp";
import s650sec1 from "../../../assets/s650/s650sec1.webp";
import s650sec2 from "../../../assets/s650/s650sec2.webp";
import s650sec3 from "../../../assets/s650/s650sec3.webp";
import s650sec4 from "../../../assets/s650/s650sec4.webp";
import s650sec5 from "../../../assets/s650/s650sec5.webp";
import s650sec6 from "../../../assets/s650/s650sec6.webp";

const S650 = () => {
  const data = {
    title: "ALUMIL S650",
    subtitle: "Minimal Sliding Insulated System SUPREME S650 PHOS",
    description:
      "The thermally insulated sliding system SUPREME S650 PHOS is the ideal solution for projects requiring wide spans with minimal aluminium sight lines. Massive yet elegant glazing surfaces are achieved while maintaining high functionality, performance, and minimal architectural design.",
    specifications: [
      { label: "WINDOW TYPES", value: "Sliding" },
      { label: "THERMAL INSULATION", value: "Yes" },
      { label: "MAXIMUM GLAZING THICKNESS", value: "46 mm" },
      { label: "MINIMUM VISIBLE ALUMINIUM FACE WIDTH", value: "25 mm" },
      { label: "WATER TIGHTNESS", value: "Class 9A" },
      { label: "AIR PERMEABILITY", value: "Class 4" },
    ],
    renders: [s650Cover, s650a, s650b, s650c, s650d],
    typologies: [
      { image: s6501, caption: "Double horizontal sliding sash" },
      { image: s6502, caption: "Single sliding sash with fixed light" },
      { image: s6503, caption: "Four horizontal sliding sashes" },
      { image: s6504, caption: "Double horizontal sliding sash meeting stile with fixed lights" },
      { image: s6505, caption: "Corner typology window, with horizontal parallel sliding sashes" },
      { image: s6506, caption: "Corner typology with two sliding sashes and fixed lights" },
      { image: s6507, caption: "Triple horizontal sliding sash" },
      { image: s6508, caption: "Four horizontal sliding sashes" },
    ],
    sections: [s650sec1, s650sec2, s650sec3, s650sec4, s650sec5, s650sec6],
    relatedFiles: [
      {
        label: "SUPREME Systems",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/general/supreme-brochure-gr-en.pdf?sfvrsn=5bdefc43_90",
      },
      {
        label: "S650 System Specs",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/pre-qualification-files/supreme/preq-supreme-s650.pdf?sfvrsn=dab5ad74_32",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default S650;